import WebServiceRequest from "../../Api/WebServiceRequest";

class PlansGetAll extends WebServiceRequest {
  constructor(context) {
    super(context);
  }
  setParams(data) {
    super.setTag(
      "Plan/GetAll?pageNumber=" + data.pageNumber + "&count=" + data.count
    );
  }
}
export default PlansGetAll;
